<template>
  {{ formattedDuration }}
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted, computed } from 'vue';

interface Props {
  startDate: Date | string;
}

const props = defineProps<Props>();

// Convert string date to Date object if needed
const getStartDate = computed(() => {
  return props.startDate instanceof Date ? props.startDate : new Date(props.startDate);
});

// Store the current time difference
const timeDifference = ref(0);

// Format the duration into a readable string
const formattedDuration = computed(() => {
  const seconds = Math.floor(timeDifference.value / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes % 60).padStart(2, '0');
  // const formattedSeconds = String(seconds % 60).padStart(2, '0');
  // return `${formattedHours}H :${formattedMinutes}M :${formattedSeconds}S`;
  return `${formattedHours}:${formattedMinutes}`;
});

// Update timer reference
let timer: number | null = null;

// Update time difference
const updateTimeDifference = () => {
  const now = new Date();
  timeDifference.value = now.getTime() - getStartDate.value.getTime();
};

// Setup timer on component mount
onMounted(() => {
  updateTimeDifference(); // Initial update
  timer = window.setInterval(updateTimeDifference, 1000);
});

// Cleanup timer on component unmount
onUnmounted(() => {
  if (timer !== null) {
    clearInterval(timer);
    timer = null;
  }
});
</script>
